//complete!
export const Pokemon = [
  'bulbasaur',
  'ivysaur',
  'venosaur',
  'squirtle',
  'wartortle',
  'blastoise',
  'charmander',
  'charmeleon',
  'charizard',
  'caterpie',
  'metapod',
  'butterfree',
  'weedle',
  'kakuna',
  'beedril',
  'pidgey',
  'pidgeoto',
  'pidgeot',
  'sparrow',
  'fearrow',
  'nidoran',
  'nidorina',
  'nidorino',
  'nidoking',
  'nidoqueen',
  'rhyhorn',
  'rhydon',
  'pikachu',
  'raichu',
  'voltorb',
  'electrode',
  'bellsprout',
  'weepinbell',
  'victreebell',
  'venonat',
  'venomoth',
  'electabuzz',
  'magmar',
  'magikarp',
  'gyarados',
  'clefairy',
  'clefable',
  'jigglypuff',
  'wigglytuff',
  'abra',
  'kadabra',
  'alakazam',
  'ekans',
  'arbok',
  'koffing',
  'weezing',
  'grimer',
  'muk',
  'gastly',
  'haunter',
  'gengar',
  'machop',
  'machoke',
  'machamp',
  'hitmonlee',
  'hitmonchan',
  'eevee',
  'flareon',
  'jolteon',
  'vaporeon',
  'leafeon',
  'glaceon',
  'sylvion',
  'umbreon',
  'espeon',
  'mankey',
  'primeape',
  'horsea',
  'seedra',
  'goldeen',
  'seaking',
  'seel',
  'dewgong',
  'tentacool',
  'tentacruel',
  'shellder',
  'cloyster',
  'slowpoke',
  'slowbro',
  'slowking',
  'staryu',
  'starmie',
  'kangaskhan',
  'pinsir',
  'scyther',
  'kabuto',
  'kabutops',
  'omanyte',
  'omastar',
  'aerodactyl',
  'dratini',
  'dragonair',
  'dragonite',
  'geodude',
  'graveler',
  'golem',
  'exeggcute',
  'exeggcutor',
  'onix',
  'tangela',
  'oddish',
  'gloom',
  'vileplume',
  'mew',
  'mewtwo',
  'articuno',
  'zapdos',
  'moltres',
  'growlithe',
  'arcanine',
  'meowth',
  'persian',
  'ponyta',
  'rapidash',
  'mr. mime',
  'jynx',
  'paras',
  'parasect',
  'drowzee',
  'hypno',
  'chansey',
  'cubone',
  'marowak',
  'diglett',
  'dugtrio',
  'porygon',
  'ditto',
  'doduo',
  'dodrio',
  'farfetch\'d',
  'psyduck',
  'golduck',
  'zubat',
  'golbat',
  'krabby',
  'kingler',
  'lapras',
  'lickitung',
  'magnemite',
  'magneton',
  'vulpix',
  'ninetales',
  'poliwag',
  'poliwhirl',
  'poliwrath',
  'rattata',
  'raticate',
  'sandshrew',
  'sandslash',
  'snorlax',
  'tauros',
  'chikorita',
  'bayleef',
  'meganium',
  'cyndaquil',
  'quilava',
  'typhlosion',
  'totodile',
  'croconaw',
  'feraligatr',
  'sentret',
  'furret',
  'hoothoot',
  'noctowl',
  'ledyba',
  'ledian',
  'spinarak',
  'ariados',
  'crobat',
  'chinchou',
  'lanturn',
  'pichu',
  'elekid',
  'hitmontop',
  'cleffa',
  'igglybuff',
  'togepi',
  'togetic',
  'togekiss',
  'natu',
  'xatu',
  'mareep',
  'flaaffy',
  'ampharos',
  'bellossom',
  'marill',
  'azumarill',
  'sudowoodo',
  'politoed',
  'hoppip',
  'skiploom',
  'jumpluff',
  'aipom',
  'sunkern',
  'sunflora',
  'yanma',
  'wooper',
  'quagsire',
  'murkrow',
  'misdreavus',
  'unown',
  'wobbuffet',
  'girafarig',
  'pineco',
  'forretress',
  'dunsparce',
  'gligar',
  'steelix',
  'snubbull',
  'granbull',
  'qwilfish',
  'scizor',
  'shuckle',
  'heracross',
  'sneasel',
  'teddiursa',
  'ursaring',
  'slugma',
  'magcargo',
  'swinub',
  'piloswine',
  'corsola',
  'remoraid',
  'octillery',
  'delibird',
  'mantine',
  'skarmory',
  'houndour',
  'houndoom',
  'kingdra',
  'phanpy',
  'donphan',
  'stantler',
  'smeargle',
  'tyrogue',
  'smoochum',
  'magby',
  'miltank',
  'blissey',
  'raikou',
  'entei',
  'suicune',
  'larvitar',
  'pupitar',
  'tyranitar',
  'lugia',
  'ho-oh',
  'celebi',
  'treecko',
  'grovyle',
  'sceptile',
  'torchic',
  'combusken',
  'blaziken',
  'mudkip',
  'marshtomp',
  'swampert',
  'poochyena',
  'mightyena',
  'zigzagoon',
  'linoone',
  'wurple',
  'silcoon',
  'cascoon',
  'beautifly',
  'dustox',
  'lotad',
  'lombre',
  'ludicolo',
  'seedot',
  'nuzleaf',
  'shiftry',
  'taillow',
  'swellow',
  'wingull',
  'pelipper',
  'ralts',
  'kirilia',
  'gardevoir',
  'surskit',
  'masquerain',
  'shroomish',
  'breloom',
  'slakoth',
  'vigoroth',
  'slaking',
  'nincada',
  'ninjask',
  'shedinja',
  'whismur',
  'loudred',
  'exploud',
  'makuhita',
  'hariyama',
  'azurill',
  'nosepass',
  'skitty',
  'delcatty',
  'sableye',
  'mawile',
  'aron',
  'lairon',
  'aggron',
  'meditite',
  'medicham',
  'electrike',
  'manectric',
  'plusle',
  'minun',
  'volbeat',
  'illumise',
  'roselia',
  'gulpin',
  'swalot',
  'carvanha',
  'sharpedo',
  'wailmer',
  'wailord',
  'numel',
  'camerupt',
  'torkoal',
  'spoink',
  'grumpig',
  'spinda',
  'trapinch',
  'vibrava',
  'flygon',
  'cacnea',
  'cacturne',
  'swablu',
  'altaria',
  'zangoose',
  'seviper',
  'lunatone',
  'solrock',
  'barboach',
  'whiscash',
  'corphish',
  'crawdaunt',
  'baltoy',
  'claydol',
  'lileep',
  'cradily',
  'anorith',
  'armaldo',
  'feebas',
  'milotic',
  'castform',
  'kecleon',
  'shuppet',
  'baneete',
  'duskull',
  'dusclops',
  'tropius',
  'chimecho',
  'absol',
  'wynaut',
  'snorunt',
  'glalie',
  'spheal',
  'sealeo',
  'walrein',
  'clamperl',
  'huntail',
  'gorebyss',
  'relicanth',
  'luvdisc',
  'bagon',
  'shelgon',
  'salamence',
  'beldum',
  'metang',
  'metagross',
  'regirock',
  'regice',
  'registeel',
  'latias',
  'latios',
  'kyogre',
  'groudon',
  'rayquaza',
  'jirachi',
  'deoxys',
  'turtwig',
  'grotle',
  'torterra',
  'chimchar',
  'monferno',
  'infernape',
  'piplup',
  'prinplup',
  'empoleon',
  'starly',
  'staravia',
  'staraptor',
  'bidoof',
  'bibarel',
  'kricketot',
  'kricketune',
  'shinx',
  'luxio',
  'luxray',
  'budew',
  'roserade',
  'cranidos',
  'rampardos',
  'shieldon',
  'bastiodon',
  'burmy',
  'wormadam',
  'mothim',
  'combee',
  'vespiqueen',
  'pachirisu',
  'buizel',
  'floatzel',
  'cherubi',
  'cherrim',
  'shellos',
  'gastrodon',
  'ambipom',
  'drifloon',
  'drifblim',
  'buneary',
  'lopunny',
  'mismagius',
  'honchkrow',
  'glameow',
  'purugly',
  'chingling',
  'stunky',
  'skunktank',
  'bronzor',
  'bronzong',
  'bonsly',
  'mime jr.',
  'happiny',
  'chatot',
  'spiritomb',
  'gible',
  'gabite',
  'garchomp',
  'munchlax',
  'riolu',
  'lucario',
  'hippopotas',
  'hippowdon',
  'skorupi',
  'drapion',
  'croagunk',
  'toxicroak',
  'carnivine',
  'finneon',
  'lumineon',
  'mantyke',
  'snover',
  'abomasnow',
  'weavile',
  'magnezone',
  'lickilicky',
  'rhyperior',
  'electivire',
  'tangrowth',
  'magmortar',
  'yanmega',
  'gliscor',
  'mamoswine',
  'porygon-z',
  'gallade',
  'probopass',
  'dusknoir',
  'froslass',
  'rotom',
  'uxie',
  'mespirit',
  'azelf',
  'diagla',
  'palkia',
  'heatran',
  'regigigas',
  'giratina',
  'cresselia',
  'darkrai',
  'shaymin',
  'phione',
  'manaphy',
  'arceus',
  'victini',
  'snivy',
  'servine',
  'serperior',
  'tepig',
  'pignite',
  'emboar',
  'oshawott',
  'dewott',
  'samurott',
  'patrat',
  'watchog',
  'lillipup',
  'herdier',
  'stoutland',
  'purrloin',
  'liepard',
  'pansage',
  'simisage',
  'pansear',
  'simisear',
  'panpour',
  'simipour',
  'munna',
  'musharna',
  'pidove',
  'tranquill',
  'unfezant',
  'blitzle',
  'zebstrika',
  'roggenrola',
  'boldore',
  'gigalith',
  'woobat',
  'swoobat',
  'drilbur',
  'excadrill',
  'audino',
  'timburr',
  'gurdurr',
  'conkeldurr',
  'tympole',
  'palpitoad',
  'seismitoad',
  'throh',
  'sawk',
  'sewaddle',
  'swadloon',
  'leavanny',
  'venipede',
  'whirlipede',
  'scolipede',
  'cottonee',
  'whimsicott',
  'petilil',
  'lilligant',
  'basculin',
  'sandile',
  'krokorok',
  'krookodile',
  'darumaka',
  'darmanitan',
  'maractus',
  'dwebble',
  'crustle',
  'scraggy',
  'scrafty',
  'sigilyph',
  'yamask',
  'cofagrigus',
  'tirtouga',
  'carracosta',
  'archen',
  'archeops',
  'trubbish',
  'garbodor',
  'zorua',
  'zoroark',
  'minccino',
  'cinccino',
  'gothita',
  'gothorita',
  'gothitelle',
  'solosis',
  'duosion',
  'reuniclus',
  'ducklett',
  'swanna',
  'vanillite',
  'vanillish',
  'vanilluxe',
  'deerling',
  'sawsbuck',
  'emolga',
  'karrablast',
  'escavlier',
  'foongus',
  'amoonguss',
  'frillish',
  'jellicent',
  'alomomola',
  'joltik',
  'galvantula',
  'ferroseed',
  'ferrothorn',
  'klink',
  'klang',
  'klinklang',
  'tynamo',
  'eelektrik',
  'eelektross',
  'elgyem',
  'beheeyem',
  'litwick',
  'lampent',
  'chandelure',
  'axew',
  'fraxure',
  'haxorus',
  'cubchoo',
  'beartic',
  'cryogonal',
  'shelmet',
  'accelgor',
  'stunfisk',
  'mienfoo',
  'mienshao',
  'druddigon',
  'golett',
  'golurk',
  'pawniard',
  'bisharp',
  'bouffalant',
  'rufflet',
  'braviary',
  'vullaby',
  'mandibuzz',
  'heatmor',
  'durant',
  'deino',
  'zweilous',
  'hydreigon',
  'larvesta',
  'volcarona',
  'cobalion',
  'terrakion',
  'virizion',
  'tornadus',
  'thundurus',
  'reshiram',
  'zekrom',
  'landorus',
  'kyurem',
  'keldeo',
  'meloetta',
  'genesect',
  'chespin',
  'quilladin',
  'chesnaught',
  'fennekin',
  'braixen',
  'delphox',
  'froakie',
  'frogadier',
  'greninja',
  'bunnelby',
  'diggersby',
  'fletchling',
  'fletchinder',
  'talonflame',
  'scatterbug',
  'spewpa',
  'vivillon',
  'litleo',
  'pyroar',
  'flabébé',
  'floette',
  'florges',
  'skiddo',
  'gogoat',
  'pancham',
  'pangoro',
  'furfrou',
  'espurr',
  'meowstic',
  'honedge',
  'doublade',
  'aegislash',
  'spritzee',
  'aromatisse',
  'swirlix',
  'slurpuff',
  'inkay',
  'malamar',
  'binacle',
  'barbaracle',
  'skrelp',
  'dragalge',
  'clauncher',
  'clawitzer',
  'helioptile',
  'heliolisk',
  'tyrunt',
  'tyrantrum',
  'amaura',
  'aurorus',
  'hawlucha',
  'dedenne',
  'carbink',
  'goomy',
  'sliggoo',
  'goodra',
  'klefki',
  'phantump',
  'trevenant',
  'pumpkaboo',
  'gourgeist',
  'bergmite',
  'avalugg',
  'noibat',
  'noivern',
  'xerneas',
  'yveltal',
  'zygarde',
  'diancie',
  'hoopa',
  'volcanion',
  'rowlet',
  'dartrix',
  'decidueye',
  'litten',
  'torracat',
  'incineroar',
  'popplio',
  'brionne',
  'primarina',
  'pikipek',
  'trumbeak',
  'toucannon',
  'yungoos',
  'gumshoos',
  'grubbin',
  'charjabug',
  'vikavolt',
  'crabrawler',
  'crabominable',
  'oricorio',
  'cutiefly',
  'ribombee',
  'rockruff',
  'lycanroc',
  'wishiwashi',
  'mareanie',
  'toxapex',
  'mudbray',
  'mudsdale',
  'dewpider',
  'araquanid',
  'fomantis',
  'lurantis',
  'morelull',
  'shiinotic',
  'salandit',
  'salazzle',
  'stufful',
  'bewear',
  'bounsweet',
  'steenee',
  'tsareena',
  'comfey',
  'oranguru',
  'passimian',
  'wimpod',
  'golisopod',
  'sandygast',
  'palossand',
  'pyukumuku',
  'type: null',
  'silvally',
  'minior',
  'komala',
  'turtonator',
  'togedemaru',
  'mimikyu',
  'bruxish',
  'drampa',
  'dhelmise',
  'jangmo-o',
  'hakamo-o',
  'kommo-o',
  'tapu koko',
  'tapu lele',
  'tapu bulu',
  'tapu fini',
  'cosmog',
  'cosmoem',
  'solgaleo',
  'lunala',
  'nihilego',
  'buzzwole',
  'pheromosa',
  'xurkitree',
  'celesteela',
  'kartana',
  'guzzlord',
  'necrozma',
  'magearna',
  'marshadow',
  'poipole',
  'naganadel',
  'stakataka',
  'blacephalon',
  'zeraora',
  'meltan',
  'melmetal',
  'grookey',
  'thwackey',
  'rillaboom',
  'scorbunny',
  'raboot',
  'cinderace',
  'sobble',
  'drizzile',
  'inteleon',
  'skwovet',
  'greedent',
  'rookidee',
  'corvisquire',
  'corviknight',
  'blipbug',
  'dottler',
  'orbeetle',
  'nickit',
  'thievul',
  'gossifleur',
  'eldegoss',
  'wooloo',
  'dubwool',
  'chewtle',
  'drednaw',
  'yamper',
  'boltund',
  'rolycoly',
  'carkol',
  'coalossal',
  'applin',
  'flapple',
  'appletun',
  'silicobra',
  'sandaconda',
  'cramorant',
  'arrokuda',
  'barraskewda',
  'toxel',
  'toxtricity',
  'sizzlipede',
  'centiskorch',
  'clobbopus',
  'grapploct',
  'sinistea',
  'polteageist',
  'hatenna',
  'hattrem',
  'hatterene',
  'impidimp',
  'morgrem',
  'grimmsnarl',
  'obstagoon',
  'perrserker',
  'cursola',
  'sirfetch\'d',
  'mr. rime',
  'runerigus',
  'milcery',
  'alcremie',
  'falinks',
  'pincurchin',
  'snom',
  'frosmoth',
  'stonjourner',
  'eiscue',
  'indeedee',
  'morpeko',
  'cufant',
  'copperajah',
  'dracozolt',
  'arctozolt',
  'dragovish',
  'arctovish',
  'duraludon',
  'dreepy',
  'drakloak',
  'dragapult',
  'zacian',
  'zamazenta',
  'eternatus',
  'kubfu',
  'urshifu',
  'zarude',
  'regieleki',
  'regidrago',
  'glastrier',
  'spectrier',
  'calyrex',
  'wyrdeer',
  'kleavor',
  'ursaluna',
  'basculegion',
  'sneasler',
  'overqwil',
  'enamorus',
  'sprigatito',
  'floragato',
  'meowscarada',
  'fuecoco',
  'crocalor',
  'skeledirge',
  'quaxly',
  'quaxwell',
  'quaquaval',
  'lechonk',
  'oinkologne',
  'dudunsparce',
  'tarountula',
  'spidops',
  'nymble',
  'lokix',
  'rellor',
  'rabsca',
  'greavard',
  'houndstone',
  'flittle',
  'espathra',
  'farigiraf',
  'wiglett',
  'wugtrio',
  'dondozo',
  'veluza',
  'finizen',
  'palafin',
  'smoliv',
  'dolliv',
  'arboliva',
  'capsakid',
  'scovillain',
  'tadbulb',
  'bellibolt',
  'varoom',
  'revavroom',
  'orthworm',
  'tandemaus',
  'maushold',
  'cetoddle',
  'cetitan',
  'frigibax',
  'arctibax',
  'baxcalibur',
  'tatsugiri',
  'cyclizar',
  'pawmi',
  'pawmo',
  'pawmot',
  'wattrel',
  'kilowattrel',
  'bombirdier',
  'squawkabilly',
  'flamigo',
  'klawf',
  'nacli',
  'naclstack',
  'garganacl',
  'glimmet',
  'glimmora',
  'shroodle',
  'grafaiai',
  'fidough',
  'dachsbun',
  'maschiff',
  'mabosstiff',
  'bramblin',
  'brambleghast',
  'gimmighoul',
  'gholdengo',
  'great tusk',
  'brute bonnet',
  'sandy shocks',
  'scream tail',
  'flutter mane',
  'slither wing',
  'roaring moon',
  'iron treads',
  'iron moth',
  'iron hands',
  'iron jugulis',
  'iron thorns',
  'iron bundle',
  'iron valiant',
  'ting-lu',
  'chien-pao',
  'wo-chien',
  'chi-yu',
  'koraidon',
  'miraidon',
  'tinkatink',
  'tinkatuff',
  'tinkaton',
  'charcadet',
  'armarouge',
  'ceruledge',
  'toedscool',
  'toedscruel',
  'kingambit',
  'clodsire',
  'annihilape'
];
